import { Statistic } from 'antd';
import Countdown from 'antd/es/statistic/Countdown';
import StatisticNumber from 'antd/es/statistic//Number';
import WrapperStatistic from 'antd/es/statistic/Statistic';
export { Countdown, StatisticNumber, WrapperStatistic };
export default Statistic;
